import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const SetupBanner = () => {
    const { t } = useTranslation('default');

    return (
        <Box mb="48px">
            <Text
                fontFamily="Poppins, sans-serif"
                fontWeight="medium"
                fontSize="22px"
                color="#363636"
            >
                {t('setup.title')}
            </Text>
            <Box borderBottom="1px solid" borderColor="#0A4725" my={3} />
            <Text
                fontFamily="Poppins, sans-serif"
                fontWeight="light"
                fontSize="16px"
                color="#363636"
            >
                {t('setup.message')}
            </Text>
        </Box>
    );
};

export default SetupBanner;
